"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MappingValidator_1 = require("../Validator/MappingValidator");
const ContainerAwareFactory_1 = require("../Factory/ContainerAwareFactory");
const PluginManagerBase_1 = require("../Plugin/PluginManagerBase");
const WidgetInitializerPluginManager_1 = require("../Plugin/WidgetInitializer/WidgetInitializerPluginManager");
const WidgetInitializer_1 = require("../Widget/WidgetInitializer");
const WidgetConfigFactory_1 = require("../Factory/WidgetConfigFactory");
const WidgetStateFactory_1 = require("../Factory/WidgetStateFactory");
const WidgetFactory_1 = require("../Factory/WidgetFactory");
const WidgetStepPluginManager_1 = require("../Plugin/WidgetStep/WidgetStepPluginManager");
const WidgetStepFactory_1 = require("../Factory/WidgetStepFactory");
const RactiveComponentPluginManager_1 = require("../Plugin/RactiveComponent/RactiveComponentPluginManager");
const EventContainer_1 = require("../Event/EventContainer");
const RactiveWrapper_1 = require("../Renderer/RactiveWrapper");
const WidgetFacadeFactory_1 = require("../Factory/WidgetFacadeFactory");
const WidgetExtensionPluginManager_1 = require("../Plugin/WidgetExtension/WidgetExtensionPluginManager");
const ErrorHandler_1 = require("../Error/ErrorHandler");
const ErrorHandlerPluginManager_1 = require("../Plugin/ErrorHandler/ErrorHandlerPluginManager");
const WidgetUpdaterPluginManager_1 = require("../Plugin/WidgetUpdater/WidgetUpdaterPluginManager");
const Updater_1 = require("../Updater/Updater");
const ScrollInView_1 = require("../Service/ScrollInView");
const Path_1 = require("../Util/Path");
const HttpClient_1 = require("../HttpClient/HttpClient");
const AssetManager_1 = require("../Service/AssetManager");
/**
 * Base service definitions.
 */
exports.services = {
    "factory.container_aware": {
        class: ContainerAwareFactory_1.default,
        argumentList: [
            "@container"
        ]
    },
    "plugin.manager.default": {
        class: PluginManagerBase_1.default,
        argumentList: [
            "@factory.container_aware",
        ],
    },
    "plugin.manager.widget_initializer": {
        class: WidgetInitializerPluginManager_1.default,
        tags: { plugin_manager: { type: "widget_initializer" } },
        parent: "plugin.manager.default"
    },
    "plugin.manager.widget_step": {
        class: WidgetStepPluginManager_1.default,
        tags: { plugin_manager: { type: "widget_step" } },
        parent: "plugin.manager.default"
    },
    "plugin.manager.widget_extension": {
        class: WidgetExtensionPluginManager_1.default,
        tags: { plugin_manager: { type: "widget_extension" } },
        parent: "plugin.manager.default"
    },
    "factory.widget_config": {
        class: WidgetConfigFactory_1.default,
        argumentList: [
            "@extendable.provider"
        ]
    },
    "factory.widget_state": {
        class: WidgetStateFactory_1.default,
        argumentList: [
            "@extendable.provider",
            "@factory.container_aware",
        ]
    },
    "factory.widget_facade": {
        class: WidgetFacadeFactory_1.default,
        argumentList: [
            "@extendable.provider",
            "@factory.container_aware"
        ]
    },
    "factory.widget_step": {
        class: WidgetStepFactory_1.default,
        argumentList: [
            "@plugin.manager.widget_step"
        ]
    },
    "factory.widget": {
        class: WidgetFactory_1.default,
        argumentList: [
            "@factory.container_aware"
        ]
    },
    "event.container.global": {
        class: EventContainer_1.default,
    },
    "event.container.instance": {
        class: EventContainer_1.default,
        shared: false
    },
    "widget.initializer": {
        class: WidgetInitializer_1.default,
        argumentList: [
            '@plugin.manager.widget_initializer',
        ],
    },
    "plugin.manager.ractive_component": {
        class: RactiveComponentPluginManager_1.default,
        tags: { plugin_manager: { type: "ractive_component" } },
        parent: "plugin.manager.default"
    },
    "ractive_wrapper": {
        class: RactiveWrapper_1.RactiveWrapper,
        argumentList: [
            "@plugin.manager.ractive_component"
        ],
    },
    "mapping_validator": {
        class: MappingValidator_1.default
    },
    "plugin.manager.error_handler": {
        class: ErrorHandlerPluginManager_1.default,
        tags: { plugin_manager: { type: "error_handler" } },
        parent: "plugin.manager.default"
    },
    "error.handler": {
        class: ErrorHandler_1.default,
        argumentList: [
            "@plugin.manager.error_handler"
        ]
    },
    "plugin.manager.widget_updater": {
        class: WidgetUpdaterPluginManager_1.default,
        tags: { plugin_manager: { type: "widget_updater" } },
        parent: "plugin.manager.default"
    },
    "widget_updater": {
        class: Updater_1.default,
        argumentList: [
            "@plugin.manager.widget_updater"
        ]
    },
    "scroll_in_view": {
        class: ScrollInView_1.default
    },
    "path_utils": {
        class: Path_1.default
    },
    "http_client": {
        class: HttpClient_1.HttpClient
    },
    "asset_manager": {
        class: AssetManager_1.default
    }
};
